import {MdSnackBar} from '@angular/material';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {UserService} from '../services/user.service';
import {AuthService} from '../services/auth.service';
import {UserActions} from '../store/actions/user.actions';

const warning = 900;
const timeOut = 20;

var idleTime: number;
var timeOutCounter: number;
var countdown: any;

@Injectable()
export class UserIdle {

    constructor(private router: Router,
                private auth: AuthService,
                private userActions: UserActions,
                private userService: UserService,
                private snackBar: MdSnackBar) {
            idleTime = 0;
            timeOutCounter = timeOut;
        }

    start() {
        const self = this;

        function stopWatch() {
          clearInterval(countdown);
          countdown = undefined;
          self.snackBar.dismiss();
        };

        function sessionKeepAlive() {
          idleTime = 0;
          timeOutCounter = timeOut;
          stopWatch();
        }

        var eventList= ['click', 'mouseover', 'keydown'];
        for(let event of eventList) {
          document.body.addEventListener(event, () => {
            sessionKeepAlive();
          });
        }

        function timerIncrement() {
          var currentRoute = self.router.url;
    
          if(currentRoute != '/login'){
            if (idleTime < warning) {
              idleTime += 1;
            }
            else if(countdown == undefined) {
              startWatch();
            }
          }
        };
    
        function logout() {
          self.auth.logout().subscribe(() => {
            self.userActions.logoutUser();
            self.userService.stopKeepingSessionAlive();
            self.router.navigate(['/login']);
          });
        }

        function sessionTimeOut() {
          timeOutCounter -= 1;
    
          if(self.snackBar._openedSnackBarRef == null) {
            self.snackBar.open('You will be logged out in ' + (timeOutCounter + 1) + ' seconds due to inactivity.', null, {
              duration: 9000,
            });
          }
    
          if(timeOutCounter <= 0){
            idleTime = 0;
            timeOutCounter = timeOut;
            stopWatch();
            logout();
          }
        };

        function startWatch() {
          countdown = setInterval(sessionTimeOut, 1000);
        };

        setInterval(timerIncrement, 1000);
    }
}


// WEBPACK FOOTER //
// ./src/app/routing/user-idle.ts